<template>

    <el-popover
            placement="top-start"
            :width="canvasWidth"
            popper-class="verify-popover"
            :visible-arrow="false"
            :disabled="isSuccess"
            v-model="isSlideShow"
            trigger="manual">
        <div class="auth-body_"  :style="`height: ${canvasHeight}px`"
             @mouseleave.stop="onRangeMounseLeave($event)">
            <el-button type="text" style="color: #1890FF;position: absolute;top: 0px;right:8px;" @click="reset"><i class="el-icon-refresh"></i></el-button>
            <!-- 主图，有缺口 -->
            <img ref="img1" :src="image1" alt="" :width="canvasWidth" :height="canvasHeight">
            <!-- 小图 -->
            <img
                    ref="img2"
                    :src="image2"
                    class="auth-canvas2_"
                    :height="canvasHeight"
                    :style="`transform:translateX(${styleWidth - sliderBaseSize}px)`"
                    alt="">
            <div :class="['loading-box_', { hide_: !loading }]">
                <div class="loading-gif_">
                    <span />
                    <span />
                    <span />
                    <span />
                    <span />
                </div>
            </div>
            <div :class="['info-box_', { show: infoBoxShow }, { fail: infoBoxFail }]">
                {{ infoText }}
            </div>
            <div
                    :class="['flash_', { show: isSuccess }]"
                    :style="
                            `transform: translateX(${
                              isSuccess
                                ? `${canvasWidth + canvasHeight * 0.578}px`
                                : `-${canvasHeight * 0.578}px`
                            }) skew(-30deg, 0);`
                          "
            />
        </div>
        <div slot="reference" class="auth-control_"  :style="`width:${canvasWidth}px`">
            <div v-if="show" class="range-box" :style="`height:${sliderBaseSize}px`"

                 @mouseleave.stop="onRangeMounseLeave($event)">
                <div class="range-text">{{ isSuccess?'':sliderText }}</div>
                <div ref="range-slider" class="range-slider" :style="`width:${styleWidth}px`" @mouseenter.stop="onRangeMounseEnter($event)">
                    <div :class="['range-btn', { isDown: mouseDown }]" :style="`width:${sliderBaseSize}px`"
                         @mousedown.stop="onRangeMouseDown($event)"
                         @touchstart.stop="onRangeMouseDown($event)">
                        <div v-if="!isSuccess"/>
                        <div v-if="!isSuccess"/>
                        <div v-if="!isSuccess"/>
                        <i v-if="isSuccess" class="el-icon-check"></i>
                    </div>
                </div>
            </div>
        </div>
    </el-popover>

</template>

<script>
import axios from "axios";
const ssoHttp = axios.create({
    timeout: 1000 * 30,
    withCredentials: true,
    headers: {
        "X-Requested-With": "XMLHttpRequest",
        X_PROXY_GATEWAY: true,
        X_PROXY_REST: true,
        "Content-Type": "application/json; charset=utf-8"
    }
});
    export default {
        name: 'PuzzleCode',
        /** 父级参数 **/
        props: {
            id: { type: String, default: undefined },
            limitMoveBox:{type: String, default: '' },
            canvasWidth: { type: Number, default: 280 }, // 主canvas的宽
            canvasHeight: { type: Number, default: 150 }, // 主canvas的高
            vwh: { type: Number, default: 30 }, // 切图的宽高
            show: { type: Boolean, default: true },
            sliderSize: { type: Number, default: 35 }, // 滑块的大小
            successText: {
                type: String,
                default: '验证通过！'
            },
            failText: {
                type: String,
                default: '验证失败，请重试'
            },
            sliderText: {
                type: String,
                default: '拖动滑块完成拼图'
            },
            borderRadius: {
                type: Number,
                default: 2
            }
        },
        /** 私有数据 **/
        data() {
            return {
                image1: undefined, // 大图
                image2: undefined, // 小图
                mouseDown: false, // 鼠标是否在按钮上按下
                showImg:false,
                isSlideShow:false,
                mouseEnter:false,
                startWidth: 35, // 鼠标点下去时父级的width
                startX: 0, // 鼠标按下时的X
                newX: 0, // 鼠标当前的偏移X
                loading: true, // 是否正在加载中，主要是等图片onload
                isCanSlide: false, // 是否可以拉动滑动条
                error: false, // 图片加在失败会出现这个，提示用户手动刷新
                infoBoxShow: false, // 提示信息是否出现
                infoText: '', // 提示等信息
                infoBoxFail: false, // 是否验证失败
                timer1: null, // setTimout1
                closeDown: false, // 为了解决Mac上的click BUG
                isSuccess: false, // 验证成功
                // resetSvg,
                isSubmit: false // 是否正在验证中
            }
        },
        /** 计算属性 **/
        computed: {
            // styleWidth是底部用户操作的滑块的父级，就是轨道在鼠标的作用下应该具有的宽度
            styleWidth() {
                const w = this.startWidth + this.newX - this.startX
                return w < this.sliderBaseSize
                    ? this.sliderBaseSize
                    : w > this.canvasWidth
                        ? this.canvasWidth
                        : w
            },
            // 处理一下sliderSize，弄成整数，以免计算有偏差
            sliderBaseSize() {
                return Math.max(
                    Math.min(
                        Math.round(this.sliderSize),
                        Math.round(this.canvasWidth * 0.5)
                    ),
                    10
                )
            }
        },

        /** 监听 **/
        watch: {
            show(newV) {
                // this.reset()
            }
        },

        /** 生命周期 **/
        mounted() {
            var moveLimitBox = this.limitMoveBox?document.getElementById(this.limitMoveBox):document;
            moveLimitBox.addEventListener('mousemove', this.onRangeMouseMove, false)
            moveLimitBox.addEventListener('mouseup', this.onRangeMouseUp, false)
            moveLimitBox.addEventListener('touchmove', this.onRangeMouseMove, {
                passive: false
            })
            moveLimitBox.addEventListener('touchend', this.onRangeMouseUp, false)
            if(this.show){
                // this.init()
            }
        },
        beforeDestroy() {
            this.removeEventListener()
        },

        /** 方法 **/
        methods: {
            removeEventListener() {
                var moveLimitBox = this.limitMoveBox?document.getElementById(this.limitMoveBox):document;
                moveLimitBox.removeEventListener('mousemove', this.onRangeMouseMove, false)
                moveLimitBox.removeEventListener('mouseup', this.onRangeMouseUp, false)
                moveLimitBox.removeEventListener('touchmove', this.onRangeMouseMove, {
                    passive: false
                })
                moveLimitBox.removeEventListener('touchend', this.onRangeMouseUp, false)
            },
            // 鼠标移入
            onRangeMounseEnter() {
                if (!this.isCanSlide) {
                    this.init()
                }
                this.mouseEnter = true;
                // tab 切换过程中，如果鼠标移入影响位置计算
                setTimeout(() => {
                    this.isSlideShow = true;
                }, 300);
            },
            // 鼠标移出
            onRangeMounseLeave() {
                this.mouseEnter = false;
                if (this.mouseDown) { // 如果鼠标是按下状态，即使鼠标拖出去图片和滑块区域了，也不要隐藏图片滑块验证
                    return
                }
                setTimeout(()=>{  // 500毫秒后隐藏图片，避免出现闪烁效果
                    if(!this.mouseEnter){
                        this.isSlideShow = false;
                    }
                },500)

            },
            // 鼠标按下准备拖动
            onRangeMouseDown(e) {
                if (this.isCanSlide) {
                    this.mouseDown = true;
                    this.isSlideShow = true;
                    this.startWidth = this.$refs['range-slider'].clientWidth
                    this.newX = e.clientX || e.changedTouches[0].clientX
                    this.startX = e.clientX || e.changedTouches[0].clientX
                }
            },
            // 鼠标移动
            onRangeMouseMove(e) {
                if (this.mouseDown) {
                    e.preventDefault()
                    this.newX = e.clientX || e.changedTouches[0].clientX
                }
            },
            // 鼠标抬起
            onRangeMouseUp() {
                if (this.mouseDown) {
                    this.mouseDown = false;
                    this.submit()
                }
            },
            /**
             * 初始化
             */
            init() {
                this.loading = true
                this.isCanSlide = false
                ssoHttp({
                    url:'/sso/oauth/getImageCaptchaCode',
                    method: 'post',
                    data:{
                        width:this.canvasWidth,
                        height:this.canvasHeight,
                        vwh:this.vwh
                    }
                }).then((res)=>{
                    if (res.data.code == 1) {
                        this.image1 = res.data.data.image1
                        this.image2 = res.data.data.image2
                        this.loading = false;
                        this.isCanSlide = true;
                        this.startTime = new Date().getTime()
                    }else{
                        this.$message({
                            message: res.data.msg,
                            type: 'warning'
                        });
                    }
                })
            },
            // 开始判定
            submit() {
                // 关闭拖动
                this.isCanSlide = false
                this.isSubmit = true
                const x = parseInt(this.newX - this.startX)
                this.loading = true;

                ssoHttp({
                    url:'/sso/oauth/verifyImageCaptchaCode',
                    data:{ x, width: this.canvasWidth },
                    method: 'post',
                }).then((res)=>{
                    this.isSubmit = false
                    this.loading = false
                    if(res.data.code!='1'){
                        // 失败
                        this.infoText = this.failText
                        this.infoBoxFail = true
                        this.infoBoxShow = true
                        this.isCanSlide = false
                        // 失败的回调
                        this.$emit('fail', x)
                        this.reset()
                        return;
                    }
                    this.removeEventListener()
                    // 成功
                    this.infoText = this.successText
                    this.infoBoxFail = false
                    this.isSlideShow = false;
                    this.infoBoxShow = true
                    this.isCanSlide = true
                    this.isSuccess = true
                    this.$emit('success', res.data.data || '')
                })

            },
            // 重置
            reset() {
                this.infoBoxFail = false
                this.infoBoxShow = false
                this.isCanSlide = false
                this.isSuccess = false
                this.startWidth = this.sliderBaseSize // 鼠标点下去时父级的width
                this.startX = 0 // 鼠标按下时的X
                this.newX = 0 // 鼠标当前的偏移X
                this.init()
            }
        }
    }
</script>
<style lang="less" scoped>
    .option_ {
        position: absolute;
        top: -6px;
        right: 6px;
        width: 90px;
        opacity: 0.6;
        height: auto;
        z-index: 12;
        cursor: pointer;
    }
    .auth-body_ {
        position: relative;
        overflow: hidden;
        border-radius: 3px;
        .loading-box_ {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            background-color: rgba(0, 0, 0, 0.8);
            z-index: 20;
            opacity: 1;
            transition: opacity 200ms;
            display: flex;
            align-items: center;
            justify-content: center;
            &.hide_ {
                opacity: 0;
                pointer-events: none;
                .loading-gif_ {
                    span {
                        animation-play-state: paused;
                    }
                }
            }
            .loading-gif_ {
                flex: none;
                height: 5px;
                line-height: 0;
                @keyframes load {
                    0% {
                        opacity: 1;
                        transform: scale(1.3);
                    }
                    100% {
                        opacity: 0.2;
                        transform: scale(0.3);
                    }
                }
                span {
                    display: inline-block;
                    width: 5px;
                    height: 100%;
                    margin-left: 2px;
                    border-radius: 50%;
                    background-color: #888;
                    animation: load 1.04s ease infinite;
                    &:nth-child(1) {
                        margin-left: 0;
                    }
                    &:nth-child(2) {
                        animation-delay: 0.13s;
                    }
                    &:nth-child(3) {
                        animation-delay: 0.26s;
                    }
                    &:nth-child(4) {
                        animation-delay: 0.39s;
                    }
                    &:nth-child(5) {
                        animation-delay: 0.52s;
                    }
                }
            }
        }
        .info-box_ {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 24px;
            line-height: 24px;
            text-align: center;
            overflow: hidden;
            font-size: 13px;
            background-color: #83ce3f;
            opacity: 0;
            transform: translateY(24px);
            transition: all 200ms;
            color: #fff;
            z-index: 10;
            &.show {
                opacity: 0.95;
                transform: translateY(0);
            }
            &.fail {
                background-color: #ce594b;
            }
        }
        .auth-canvas2_ {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;
        }
        .auth-canvas3_ {
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
            transition: opacity 600ms;
            z-index: 3;
            &.show {
                opacity: 1;
            }
        }
        .flash_ {
            position: absolute;
            top: 0;
            left: 0;
            width: 30px;
            height: 100%;
            background-color: rgba(255, 255, 255, 0.1);
            z-index: 3;
            &.show {
                transition: transform 600ms;
            }
        }
    }
    .auth-control_ {
        position: relative;
        left: -1px;
        .range-box {
            position: relative;
            width: 100%;
            background-color: #eef1f8;
            margin-top: 16px;
            border-radius: 3px;
            box-shadow: 0 0 8px rgba(240, 240, 240, 0.6) inset;
            .range-text {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: 14px;
                color: #b7bcd1;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                text-align: center;
                width: 100%;
            }
            .range-slider {
                position: absolute;
                height: 100%;
                width: 50px;
                background-color: rgba(106, 160, 255, 0.8);
                border-radius: 3px;
                .range-btn {
                    position: absolute;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    right: 0;
                    width: 50px;
                    height: 100%;
                    background-color: #fff;
                    border-radius: 3px;
                    box-shadow: 0 0 4px #ccc;
                    cursor: pointer;
                    & > div {
                        width: 0;
                        height: 40%;
                        transition: all 200ms;
                        &:nth-child(2) {
                            margin: 0 4px;
                        }
                        border: solid 1px #6aa0ff;
                    }
                    &:hover,
                    &.isDown {
                        & > div:first-child {
                            border: solid 4px transparent;
                            height: 0;
                            border-right-color: #6aa0ff;
                        }
                        & > div:nth-child(2) {
                            border-width: 3px;
                            height: 0;
                            border-radius: 3px;
                            margin: 0 6px;
                            border-right-color: #6aa0ff;
                        }
                        & > div:nth-child(3) {
                            border: solid 4px transparent;
                            height: 0;
                            border-left-color: #6aa0ff;
                        }
                    }
                }
            }
        }
    }


</style>
